import { Component, Input, OnInit } from '@angular/core';
import { ShopcartService } from 'core-lib';
import { ICartItem, IExtraCartItem, IShopCart } from 'core-lib';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { EditExtraDialogComponent } from '../edit-extra-dialog/edit-extra-dialog.component';
import { StripTagsPipe } from '../../pipes/stripTags.pipe';

@Component({
    selector: 'app-payment-summary',
    imports: [TranslateModule, CurrencyPipe, ButtonModule, EditExtraDialogComponent, DatePipe, StripTagsPipe],
    templateUrl: './payment-summary.component.html',
    styleUrl: './payment-summary.component.scss'
})
export class PaymentSummaryComponent implements OnInit {

  @Input() shopCart:IShopCart;
  rooms:ICartItem[];
  language:string;
  daysDelta:number;
  extrasToEdit:null|IExtraCartItem[] = null

  constructor(public shopCartService: ShopcartService, private translateService: TranslateService)  {
      
  }

  ngOnInit(): void {
      this.rooms = this.shopCart.getCartItemsByType('roomrate');
      this.language = this.translateService.currentLang;
      this.daysDelta = this.shopCart.getDaysDelta();
  }

  
  editExtra(extra:IExtraCartItem) {
    let editables:IExtraCartItem[] = [];
    this.shopCart.getCartItemsByType('roomrate').forEach((item:ICartItem, index:number) => {
      let existingExtra:IExtraCartItem|undefined = item.getExtraById(extra.rateId);
      if (existingExtra) {
        editables.push(JSON.parse(JSON.stringify(existingExtra)));
      }
      else {
        let e:any = JSON.parse(JSON.stringify(extra));
        e.quantity = 0;
        let newExtra:IExtraCartItem = e;
        
        editables.push(newExtra)
      }
    });
    this.extrasToEdit = editables;
  }

  updateEditExtraQuantity(value:number, index:number) {
    if (this.extrasToEdit) {
      this.extrasToEdit[index].quantity = value;
      this.shopCartService.editExtrasForAllRooms(this.extrasToEdit);
    }
  }

  hideEditExtraDialog() {
    this.extrasToEdit = null;
  } 

}
